module.exports = __webpack_public_path__ + "img/1.75712366.jpg";